/* 
Uses functions and variables from asset files
- 'size-guide-main.js'
*/
function loadTablesSizeGuidePage(brand) {
    let atLeastOneSizeChart = false;
    let sizeGuidePagesURL = {
        mens: `/pages/${brand}-size-guide-mens?view=blank`,
        womens: `/pages/${brand}-size-guide-womens?view=blank`,
        unisex: `/pages/${brand}-size-guide-unisex?view=blank`,
        kids: `/pages/${brand}-size-guide-kids?view=blank`,
    };

    Promise.all([fetch(sizeGuidePagesURL.mens), fetch(sizeGuidePagesURL.womens), fetch(sizeGuidePagesURL.unisex), fetch(sizeGuidePagesURL.kids)]) //Ajax call to get all the size pages.
        .then(function (responses) {
            return Promise.all(
                responses.map(function (response) {
                    if (response.ok) {
                        atLeastOneSizeChart = true;
                        return response.text();
                    }
                })
            );
        })
        .then((response) => {
            document.getElementById('loadingSizeTables').style.display = 'none';
            
            response.forEach(function (data, index) {
                try {
                    parseAndAppendTable(data, __sizeGuideContainersId[index], true);
                } catch {
                    console.log(`${__sizeGuideContainersId[index]} for ${brand} is unavailable.`);
                }
            });

            options.style.pointerEvents = "auto";
            return;
        });
}

const options = document.getElementById('sizeBrandOptions');
const sizeBrandImageContainer = document.getElementById('sizeBrandImageWrapper');

options.addEventListener('change', function () {
    options.style.pointerEvents = "none";
    resetCollapsibleTables();

    document.getElementById('loadingSizeTables').style.display = 'block';
    
    let brandTitle = this[this.selectedIndex].value;
    let brandLogo = this[this.selectedIndex].getAttribute('data-brand-logo');
    let brandUrl = this[this.selectedIndex].getAttribute('data-brand-collection');
    let brandHandle = this[this.selectedIndex].getAttribute('data-brand-handle');

    // Add caption for Crocs
    if(brandTitle == 'Crocs' || brandTitle == 'crocs') {
        document.getElementById('sizePageDisclamer').innerHTML = '<span class="size-table-container--disclaimer">*Please note: The sizes listed are UK sizes but the product sole displays US size.</span>';
    } else {
        document.getElementById('sizePageDisclamer').innerHTML = '';
    }

    document.querySelectorAll('.is-available').forEach(function (e) {//Resets all the tables with 'is-available' class to 'is-unavailable'
        if (e.classList.contains('is-available')) {
            e.classList.remove('is-available');
            e.classList.add('is-unavailable');
        }
    });

    __sizeGuideContainersId.forEach((e) => document.querySelectorAll(`#${e} .size_chart_table`)[0].innerHTML = '');//Clears the container in which tables load
    sizeBrandImageContainer.innerHTML = ''; //Clears the image container
    sizeBrandImageContainer.innerHTML = brandLogo !== '' ? `<img title="Shop ${brandTitle}" alt="${brandTitle} Logo" class="size-brand-title-image" src="${brandLogo}">` : `<span class="size-brand-title-link">${brandTitle}</span>`;
    sizeBrandImageContainer.setAttribute("href", brandUrl);

    loadTablesSizeGuidePage(brandHandle);
})

triggerCollapsibleTables();//Fnc in size-guide-main.js